import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import Status from "../ui/Status";
import { InfoIcon } from "../utils/Icons";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import Menu from "../ui/Menu";
import Button from "../ui/Button";
import Float from "../ui/Float";

export default function InventoryIndex(props) {

    const { callback = () => { }, route = "", sort = "id" } = props;

    const menu = [
        { text: "Entry", key: KBD.E, sort: "id", action : () => callback("id") },
        { text: "ISBN", key: KBD.I, sort: "isbn", action : () => callback("isbn") },
        { text: "Title", key: KBD.T, sort: "title", action : () => callback("title") },
        { text: "Author", key: KBD.A, sort: "author", action : () => callback("author") },
        { text: "Supplier", key: KBD.S, sort: "supplier", action : () => callback("supplier") },
        { text: "Class", key: KBD.C, sort: "class", action : () => callback("class") },
        { text: "UPC", key: KBD.U, sort: "upc", action : () => callback("upc") },
    ]

    const [selected, setSelected] = useState(sort);

    useEffect(() => {

        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(selected) } },
            { key: KBD.ENTER, action: (e) => { callback(selected) } },
        ];

        const cleanup = listen(route, actions.concat(menu));
        return cleanup;
    }, [selected]);


    return (
        <div style={{ "width": "150px" }}>
            <div className="shim" /><div className="shim" />
            <Menu callback={(e) => callback(e.sort)} bordered keyName="sort" show_keys setSelected={setSelected} selected={selected} menu={menu} route={route} />
        </div>
    )
}